<template>
  <section class="hero agenda-hero">
    <video class="hero__background-video" autoplay muted loop>
      <source src="../../assets/hero/bg.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="hero__overlay"></div>
    <div class="hero__content container">
      <div class="hero__content--text">
        <h1>Our Agenda</h1>
        <h2>Don’t miss out on Sequire Investor Summit 2027!</h2>
      </div>
      <div class="hero__content--info">
        <h2 class="hero__date">
          Jan 19th - 21st, 2027
        </h2>
        <h3 class="hero__location">
          Condado Vanderbilt, Puerto Rico
        </h3>
        <div class="hero__buttons">
          <a href="https://forms.monday.com/forms/5ab96b8f289480d9d3479556bcc057e0?r=use1" target="_blank">
            <button class="hero__btn">
              Conference Pass
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </a>
          <a href="https://buy.stripe.com/4gM8wOclm2yk27l2la3cc0V" target="_blank">
            <button class="hero__btn-alt">
              Presenter Pass
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../../styles/components/hero.scss";
  </style>